/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React base styles
import typography from "assets/theme/base/typography";

function ProfileInfoCard({ title, description, info, social , professional}) {
  const labels = [];
  const values = [];
  const { size } = typography;

  // Convert this form `objectKey` of the object key in to this `object key`
  Object.keys(info).forEach((el) => {
    if (el.match(/[A-Z\s]+/)) {
      const uppercaseLetter = Array.from(el).find((i) => i.match(/[A-Z]+/));
      const newElement = el.replace(uppercaseLetter, ` ${uppercaseLetter.toLowerCase()}`);

      labels.push(newElement);
    } else {
      labels.push(el);
    }
  });

  // Push the object values into the values array
  Object.values(info).forEach((el) => values.push(el));

  // Render the card info items
  const renderItems = labels.map((label, key) => (
    <VuiBox key={label} display="flex" py={1} pr={2}>
      <VuiTypography variant="button" color="text" fontWeight="regular" textTransform="capitalize">
        {label}: &nbsp;
      </VuiTypography>
      <VuiTypography variant="button" fontWeight="regular" color="white">
        &nbsp;{values[key]}
      </VuiTypography>
    </VuiBox>
  ));

  // Render the card social media icons
  const renderSocial = social.map(({ link, icon, color }) => (
    <VuiBox
      key={color}
      component="a"
      href={link}
      target="_blank"
      rel="noreferrer"
      fontSize={size.lg}
      color="white"
      pr={1}
      pl={0.5}
      lineHeight={1}
    >
      {icon}
    </VuiBox>
  ));

  const renderProfessional = (professional) ? professional.map(({ link, icon, platform }) => (
    <VuiBox
      key={platform}
      component="a"
      href={link}
      target="_blank"
      rel="noreferrer"
      fontSize={size.lg}
      color="white"
      pr={1}
      pl={0.5}
      pb={2}
   
    >
      <Tooltip title={platform}>
        <img width="30"  alt="plaform-icon" src={icon}/>
      </Tooltip>
      
    </VuiBox>

  )) : [];

  return (
    <Card
      sx={{
        height: "100%",
      }}
    >
       { title && title.length > 0 &&
        <VuiBox display="flex" mb="14px" justifyContent="space-between" alignItems="center">
            <VuiTypography variant="lg" fontWeight="bold" color="white" textTransform="capitalize">
              {title}
            </VuiTypography>
        </VuiBox>
      }
      <VuiBox>
        { description && description.length > 0 &&
          <VuiBox mb={2} lineHeight={1} sx={{ whiteSpace: "pre-line" }}>
            <VuiTypography variant="button" color="text" fontWeight="regular">
              {description}
            </VuiTypography>
          </VuiBox>
        }
        { description && description.length > 0 && 
          <VuiBox opacity={0.3}>
            <Divider />
          </VuiBox>
        }
        <VuiBox>
          {renderItems}
          { renderSocial && renderSocial.length > 0 && <VuiBox display="flex" py={1} pr={2} color="white">
            <VuiTypography
              variant="button"
              fontWeight="regular"
              color="text"
            >
              social: &nbsp;
            </VuiTypography>
            {renderSocial}
          </VuiBox>}
        </VuiBox>

        { renderProfessional && renderProfessional.length > 0 &&
          <VuiBox opacity={0.3}>
            <Divider />
          </VuiBox>
        }
        
        { renderProfessional && renderProfessional.length > 0 &&
          <VuiTypography
            color="white"
            variant="lg" fontWeight="bold" 
          >
            You can find me on: &nbsp;
          </VuiTypography>

        }
        { renderProfessional && renderProfessional.length > 0 &&
            <VuiBox opacity={0.3}>
              <Divider />
            </VuiBox>

        }
        { renderProfessional && renderProfessional.length > 0 &&
            <VuiBox>
  {/* sx={{ "grid-auto-flow": "column", "justify-content": "space-evenly", gap: "20px" }}  */}
  {/* sx={{ display: "flex", "flex-wrap": "wrap", "gap": "20px"}} */}

              <VuiBox display="grid"  sx={{"grid-template-columns": "repeat(auto-fit, minmax(80px, 1fr))"}} py={1} pr={2} color="white">
                {renderProfessional}
              </VuiBox>
            </VuiBox>
        }

      

      </VuiBox>
    </Card>
  );
}

// Typechecking props for the ProfileInfoCard
ProfileInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  info: PropTypes.objectOf(PropTypes.string).isRequired,
  social: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ProfileInfoCard;
